import { InteractiveTable, StyledFlex, Text } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { serviceSettingsTranslationKeys } from '../../../../translations';
import {
   AdvancePaymentsSettingsFormBean,
   AdvancePaymentsSettingsFormController,
} from '../../AdvancePaymentsSettingsForm.types';

import { useTimeBasedRefundInteractiveTableColumns } from './TimeBasedRefundInteractiveTable.hooks';
import { TimeBasedRefundTableBean } from './TimeBasedRefundInteractiveTable.types';
import { TimeBasedRefundAddRow } from './buttons/TimeBasedRefundAddRow';

const t = serviceSettingsTranslationKeys.advancePayments.form.timeBasedRefundInteractiveTable;

const TIME_BASED_REFUND_INTERACTIVE_TABLE_NAME = 'timeBasedRefund';

export type TimeBasedRefundValue = TimeBasedRefundTableBean[];

type TimeBasedRefundInteractiveTableProps = Pick<
   AdvancePaymentsSettingsFormController,
   'register' | 'watch' | 'setError'
>;

export const TimeBasedRefundInteractiveTable = (props: TimeBasedRefundInteractiveTableProps): JSX.Element => {
   const columns = useTimeBasedRefundInteractiveTableColumns();

   return (
      <StyledFlex gap={10} direction='column'>
         <Text testId={'defaultRefundValue'}>
            <Translate>{t.defaultRefundValue}</Translate>
         </Text>

         <InteractiveTable<TimeBasedRefundTableBean, AdvancePaymentsSettingsFormBean>
            header={<Translate>{t.header}</Translate>}
            register={props.register}
            columns={columns}
            testId={TIME_BASED_REFUND_INTERACTIVE_TABLE_NAME}
            name={TIME_BASED_REFUND_INTERACTIVE_TABLE_NAME}
         >
            <TimeBasedRefundAddRow />
         </InteractiveTable>
      </StyledFlex>
   );
};
